Date.prototype.toLocaleDate = function () {
  const date = new Date(this.getTime())
  return new Date(date.setMinutes(date.getMinutes() - date.getTimezoneOffset()))
}

Date.prototype.toLocaleISOString = function () {
  return this.toLocaleDate().toISOString()
}

Date.prototype.toProjectDate = function (offsetSec: number) {
  const date = new Date(this.getTime())
  return new Date(date.setMinutes(date.getMinutes() + date.getTimezoneOffset() + offsetSec / 60))
}

Date.prototype.toProjectISOString = function (offsetSec: number) {
  return this.toProjectDate(offsetSec).toISOString()
}
